import { Field, ImageField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C36AccordionEnhancedItemProps = RenderingProps<
  C36AccordionEnhancedItemFields,
  C36AccordionEnhancedItemParams,
  C36AccordionEnhancedItemPlaceholder
>;

export type C36AccordionEnhancedItemFields = {
  Headline?: Field<string>;
  AlwaysVisibleText?: RichTextField;
  HeadlineImage?: ImageField;
};

export type C36AccordionEnhancedItemParams = {
  HeadlineTag?: string;
  BackgroundColor?: string;
  HeadlineIcon?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C36AccordionEnhancedItemPlaceholder = {
  'accordion-enhanced-item-content-{*}'?: {
    uid?: string;
    componentName?: string;
  }[];
};
